const ChipInput = ({ label, statusType, icon, count, onFilterChange }) => {
  return (
    <div
      onClick={() => onFilterChange(label)}
      className={`inline-flex py-1 px-5 items-center gap-2 text-sm font-medium rounded-full
        ${statusType === label ? "bg-blue-100 text-blue-700 border-blue-400" : "border-gray-300 text-gray-700 hover:bg-gray-100"}
        border cursor-pointer flex-shrink-0`} // Add flex-shrink-0 to prevent shrinking
    >
      {icon && <span className="shrink-0">{icon}</span>}
      <span className="truncate">{label}</span>
      {count !== undefined && <span className="ml-1">({count})</span>}
    </div>
  );
};

export  default ChipInput;